import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Empecé a cobrar el doble. El cliente no discute el precio.',
  name: 'Matías G.',
  city: 'Córdoba'
}, {
  quote: 'El sistema de corrección me salvó trabajos que se estaban yendo mal.',
  name: 'Roberto M.',
  city: 'Buenos Aires'
}, {
  quote: 'Mis blancos ahora generan consultas solas en Instagram.',
  name: 'Sofía C.',
  city: 'La Plata'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="border-b border-ink-700 bg-ink-950 py-16 sm:py-20" data-id="element-191" data-mp="31yl5d1xgpona">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-192" data-mp="2x11r420rlbvc">
        <div className="flex items-center gap-3" data-id="element-193" data-mp="2s2i1nrmyphy8">
          <span className="h-px w-8 bg-ink-700" aria-hidden="true" data-id="element-194" data-mp="2s42zpr8hjj0u" />
          <span className="text-[11px] font-bold uppercase tracking-[0.28em] text-ash" data-id="element-195" data-mp="v8ws66kuleb4">
            Lo que dicen
          </span>
        </div>

        <ul className="mt-8 grid gap-px bg-ink-700 md:grid-cols-3" data-id="element-196" data-mp="h5y7wcgvp92k">
          {testimonials.map((item, i) => <motion.li key={item.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="flex flex-col justify-between gap-6 bg-ink-900 p-7" data-id="element-197" data-mp="m5kjyikz0j9s" data-mpi={i}>
              <div data-id="element-198" data-mp="zyiwhhpjos0k">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-199" data-mp="14vj25rihfsr5">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-ice text-ice" aria-hidden="true" data-id="element-200" data-mp="q5lcf74wmuzu" data-mpi={s} />)}
                </div>
                <blockquote className="mt-5 text-lg font-medium leading-snug text-bone" data-id="element-201" data-mp="v3mqfdnh444g">
                  “{item.quote}”
                </blockquote>
              </div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-ash" data-id="element-202" data-mp="1nmsd857wipku">
                {item.name} · {item.city}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}